import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block"
                initial={{ y: "112%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.9, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function Eyebrow({ children, className = "" }) {
    return (
        <p className={`eyebrow-label ${className}`}>
            <span className="inline-block h-px w-8 bg-gold" aria-hidden="true" />
            {children}
        </p>
    );
}
